export enum WorkflowTemplateDetailsTabTypes {
    METADATA = "metadata",
    VISUALIZATION = "visualization",
    PROFILES = "profiles",
    SERVICES = "services"
}